<template>
  <ba-dialog
    :save="save"
    :title="$t('_connectPaxos')"
    :canSave="!canSave"
    :show-button="false"
    :show="showDialog"
    :onHide="hideDialog"
  >
    <v-container fluid grid-list-xl>
      <v-layout wrap align-center>
        <v-flex xs6 sm6 md6>
          <p>
            We recommend that the API credentials you are sharing with us be
            <b>read-only</b>.
          </p>
          <v-text-field label="Paxos Client Id (Required)" v-model="clientId"></v-text-field>
          <v-text-field label="Paxos Client Secret (Required)" v-model="clientSecret"></v-text-field>
          <v-text-field label="Paxos Scope (Required)" v-model="scope"></v-text-field>
          <v-text-field label="ItBit User ID" v-model="itBitUserId"></v-text-field>
          <v-text-field label="ItBit Key" v-model="itBitKey"></v-text-field>
          <v-text-field label="ItBit Secret" v-model="itBitSecret"></v-text-field>
          <v-autocomplete
            v-model="exchangeContactId"
            :items="contacts"
            :label="$t('_exchangeContact')"
            item-text="name"
            item-value="id"
            persistent-hint
          ></v-autocomplete>
        </v-flex>
      </v-layout>
    </v-container>
  </ba-dialog>
</template>

<script>
import gql from 'graphql-tag';
export default {
  props: ['refresh'],
  data() {
    return {
      clientId: '',
      clientSecret: '',
      scope: '',
      itBitUserId: '',
      itBitKey: '',
      itBitSecret: '',
      showDialog: false,
      exchangeContactId: '',
    };
  },
  computed: {
    canSave() {
      return this.clientId && this.clientSecret && this.scope && this.exchangeContactId;
    },
    contacts() {
      return this.$store.getters['contacts/ENABLED_CONTACTS'];
    },
  },
  watch: {
    showDialog() {
      if (this.showDialog) {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.userId = '';
      this.key = '';
      this.secret = '';
      this.exchangeContactId = '';
    },
    hideDialog() {
      this.showDialog = false;
    },
    show() {
      this.showDialog = true;
    },
    save() {
      const vars = {
        orgId: this.$store.state.currentOrg.id,
        create: {
          createPaxos: {
            clientId: this.clientId,
            clientSecret: this.clientSecret,
            scope: this.scope,
            itBitUserId: this.itBitUserId,
            itBitKey: this.itBitKey,
            itBitSecret: this.itBitSecret,
            exchangeContactId: this.exchangeContactId,
          },
        },
      };
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation CreateConnection($orgId: ID!, $create: CreateConnectionInput!) {
              createConnection(orgId: $orgId, create: $create) {
                success
                errors
                message
              }
            }
          `,
          // Parameters
          variables: vars,
        })
        .then(() => {
          this.resetForm();
          if (this.refresh) {
            this.refresh();
          }
          this.showDialog = false;
        });
    },
  },
};
</script>
